module.exports = __webpack_public_path__ + "img/icon-drive.e2a0334d.png";